'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { UpcomingSession } from '@/hooks/use-parent-data';

interface SessionsTabProps {
  sessions: UpcomingSession[];
}

export function SessionsTab({ sessions }: SessionsTabProps) {
  if (sessions.length === 0) {
    return (
      <Card>
        <CardContent className="p-6 text-center text-muted-foreground">
          No upcoming sessions scheduled.
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Upcoming Sessions (Next 2 Weeks)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {sessions.map(session => (
              <div
                key={session.id}
                className="flex items-center justify-between p-4 border rounded-lg hover:bg-muted/40"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex flex-col items-center justify-center">
                    <span className="text-xs text-primary font-medium">
                      {new Date(session.date).toLocaleDateString('en-US', { weekday: 'short' })}
                    </span>
                    <span className="text-lg font-bold text-primary">
                      {new Date(session.date).getDate()}
                    </span>
                  </div>
                  <div>
                    <p className="font-medium">
                      {session.startTime} - {session.endTime}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {session.sessionType
                        ? session.sessionType.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())
                        : 'Training'}
                      {session.courtNumber && ` \u2022 Court ${session.courtNumber}`}
                    </p>
                  </div>
                </div>
                <Badge variant="outline" className="text-primary border-primary/30">
                  Scheduled
                </Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
